import { Box, Checkbox, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "page.register.";

interface IOptIntOutCheckboxProps {
  isOptedIn: boolean;
  handleOptInChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const OptIntOutCheckbox = memo(
  ({ isOptedIn, handleOptInChange }: IOptIntOutCheckboxProps) => {
    const { t } = useTranslation();

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginY: 2,
          alignItems: "center",
          gap: 1,
        }}
      >
        <Checkbox
          sx={{ p: 0 }}
          checked={isOptedIn}
          onChange={handleOptInChange}
        />
        <Typography variant="body2">
          {t(`${translationPath}optInOutMessage`)}
        </Typography>
      </Box>
    );
  }
);
